<template>
    <div class="air_ListBox">
        <div class="search-form">
            <el-row type="flex" :gutter="20" align="middle">
                <el-col class="el-col-label" :span="8">
                    <span>订单号:</span>
                    <input
                        clearable
                        v-model="searchForm.invalidId"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>退/费编号:</span>
                    <input
                        clearable
                        v-model="searchForm.ticketNumber"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col :span="8" class="el-col-label">
                    <span>退/费时间:</span>
                    <el-date-picker
                        v-model="searchForm.refundTimeStat"
                        :picker-options='selectPickerOptions()'
                        type="date"
                        class="time_box"
                        value-format="yyyy-MM-dd"
                        @change="search"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
                <el-col :span="8" class="el-col-label">
                    <span>乘客姓名:</span>
                    <input
                        clearable
                        v-model="searchForm.passengerName"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
            </el-row>
            <div class="btn_box">
                <el-button type="primary" @click="search" size="small">搜索</el-button>
                <el-button  @click="reset" size="small">重置</el-button>
            </div>
        </div>
        <el-row>
            <el-col :span="24">
                <div class="table-nav flex-center">
          <div class="nav-item cursor"
               v-for="(item,index) in changeRecordList"
               :key="index"
               :class="{'nav-item-active':NavItemActive==index}"
               @click="statuSearch(item,index)">
               {{item.text}}
          </div>
                </div>

        <el-table :data="pageData" v-loading="loading" style="width: 100%">
          <el-table-column label="订单号" width="200" class-name="fz12">
            <template slot-scope="scope">
              <div>
                <p></p>
                <p>{{scope.row.orderNo}}</p>
              </div>
            </template>
          </el-table-column>
         <el-table-column label="航班号/行程/舱位/日期" width="200" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.routeList"
                :key="segmentEntityIndex"
              >
                <p>行程：{{segmentEntity.sCityName}}/{{segmentEntity.eCityName}}</p>
                <p>航班号：{{segmentEntity.flightNo}}</p>
                <p>舱位：{{segmentEntity.cabinCode}}</p>
                <p>日期：{{segmentEntity.beginDate}}/{{segmentEntity.beginTime}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乘机人/票号"  class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(passengerEntity,passengerEntityIndex) in scope.row.passengerList"
                :key="passengerEntityIndex"
              >{{parseInt(passengerEntityIndex) + 1}}.{{passengerEntity.psgName}}
              <span v-if="passengerEntity.ticketNumber">({{passengerEntity.ticketNumber}})</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退票时间" class-name="fz12">
            <template slot-scope="scope">
              {{scope.row.appTime}}
            </template>
          </el-table-column>
          <el-table-column label="退款金额" class-name="fz12">
            <template slot-scope="scope"> <span class="font-10">￥</span>{{Number(scope.row.amoute).toFixed(2)}}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" class-name="fz12">
            <template slot-scope="scope">
             <span>{{scope.row.statusText}}</span></template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" class-name="fz12">
            <template slot-scope="scope">
                 <el-button
                  type="text"
                  size="mini"
                  @click="remark(scope.row.orderNo)"
                >备注
                </el-button>
            </template>
          </el-table-column>
         </el-table>
                <div style="margin-bottom: 10px;"></div>
                <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                background
                @size-change="handlerSize"
                @current-change="handlerPage"
                :current-page="searchForm.currentPage"
                :page-sizes="[10,20,30,40,50]"
                :page-size="10"
                :page-count="searchForm.pageSize"
                :total="totalCount"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import scrollTop from '@/lib/common-service/scrollTop'
import list from '@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_manage_returnMoney_list'
import SetrRemark from '@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_manage_returnMoney_remark'


export default {
  data() {
    return {
      searchForm: {
        currentPage:1,
        pageSize:10
      },
      totalCount:0,
      flightAirlines: [],
      changeRecordList:[
        {text:'全部',value:1},
        {text:'处理中',value:2},
        {text:'已退款',value:3}
      ],
      NavItemActive:'',
      pageData:[],
      loading:false,
    };
  },
  created(){
    this.search()
  },
  methods: {
    statuSearch(item,index){
       this.NavItemActive = index
       this.searchForm.status = item.value
       this.search()
    },
    searchClear() {

    },
     // 日期选择
    selectPickerOptions() {
      return {
        disabledDate: time => {
            return time.getTime() > Date.now()
        }
      }
    },
    remark(order){
      this.$prompt('请填写备注信息', '备注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
             SetrRemark({remark:value,refMoneyNo:order}).then(res=>{
               res.status?
               this.$message({type:"success",message:"操作成功！"}):''
             })
        }).catch(() => {
        })
    },
    reset() {
      this.searchForm = {currentPage:1,pageSize:10}
    },
    search(pageNum) {
      let data = this.searchForm
      if(typeof pageNum == 'number'){
          data.currentPage = pageNum||1
      }else{
        data.currentPage = 1
      }
      data.refundTimeStat?data.refundTimeEnd = this.$moment().format('YYYY-MM-DD'):data.refundTimeEnd = ''
      list(data).then(res=>{
        this.pageData = res.pageResult.pageData
        this.totalCount = res.pageResult.totalCount
        scrollTop(500)
      })
    },
    handlerSize(val){
      this.searchForm.pageSize = val
      this.search()
    },
    handlerPage(val){
      // this.searchForm.currentPage = val
      this.search(val)
    }
  }
};
</script>

<style lang='less' scoped>
@import "./css/common";
</style>
